import { render, staticRenderFns } from "./ModalDocumentos.vue?vue&type=template&id=28eaa1c7"
import script from "./ModalDocumentos.vue?vue&type=script&lang=js"
export * from "./ModalDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28eaa1c7')) {
      api.createRecord('28eaa1c7', component.options)
    } else {
      api.reload('28eaa1c7', component.options)
    }
    module.hot.accept("./ModalDocumentos.vue?vue&type=template&id=28eaa1c7", function () {
      api.rerender('28eaa1c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/entregadocumentos/ModalDocumentos.vue"
export default component.exports